import React from 'react'
import context from '@/context'
import { downloadFile } from '@/utils/downloader'
import { localized } from '@/decorators/localized'

@localized()
class ExcelExport extends React.Component {
  constructor (props) {
    super(props)

    this.state = { reportId: '' }
    this.handleReportIdChange = this.handleReportIdChange.bind(this)
    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.onDownloadComplete = this.onDownloadComplete.bind(this)
  }

  handleButtonClick = (isRtl) => {
    downloadFile({ Id: this.state.reportId, EnglishTranslation: !isRtl }, context.api.reportExportService.exportReportTemplateAsExcelFile, this.onDownloadComplete)
  }

  onDownloadComplete () {
    return 1
  }

  handleReportIdChange (event) {
    this.setState({ reportId: event.target.value })
  }

  render () {
    return (
      <div className='main__body'>
        <label>
          Report ID:
          <input type='text' value={this.state.value} onChange={this.handleReportIdChange} />
        </label>
        <input type='submit' value='Download report (English)' onClick={() => this.handleButtonClick(false)} />
        <input type='submit' value='Download report (Arabic)' onClick={() => this.handleButtonClick(true)} />
      </div>
    )
  }
}

export { ExcelExport }



// WEBPACK FOOTER //
// ./src/internal-app/pages/reporting/excelExport.js